import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SefObavestenjaTableService } from '../sef-obavestenja-table.service';

@Component({
  selector: 'kodit-sef-obavestenja-page',
  templateUrl: './sef-obavestenja-page.component.html',
  styleUrls: ['./sef-obavestenja-page.component.scss'],
})
export class SefObavestenjaPageComponent implements OnInit, OnDestroy {
  private _subs = new Subscription();

  activeIndex = 0;
  allowedIndecies = [0, 1];

  constructor(
    private route: ActivatedRoute,
    private _router: Router,
    private _tableService: SefObavestenjaTableService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['activeTab']) {
        const activeTabIdx = Number.parseInt(params['activeTab']);
        if (!isNaN(activeTabIdx) && this.allowedIndecies.includes(activeTabIdx)) {
          this.activeIndex = activeTabIdx;
          this._tableService.setActiveTab = activeTabIdx;
        }
      }
    });

    this._subs.add(
      this._tableService.getActiveTab.subscribe((tabIndex) => {
        this.activeIndex = tabIndex;
      })
    );
  }

  handleIndexChange(tabIndex: number) {
    this._tableService.setActiveTab = tabIndex;
  }

  ngOnDestroy(): void {
    if (this._router.routerState.snapshot.url.indexOf('sef-obavestenja') === -1) {
      this._tableService.resetActiveTab();
    }
    this._subs.unsubscribe();
  }
}
